<template>
  <v-app>
    <v-sheet class="overflow-hidden">
      <!-- BARRA DE NAVEGACION -->
      <navbar v-if="!loggedIn && !$route.fullPath.includes('checkout')"></navbar>

      <!-- BARRA DE NAVEGACION DE ADMINISTRADOR -->
      <admin-navbar v-else-if="loggedIn && user.role == 'ORGANIZER' && !$route.fullPath.includes('checkout')"></admin-navbar>
      <admin-lite-navbar v-else-if="loggedIn && (user.role == 'LITE_ORGANIZER' || user.role == 'ADMIN') && !$route.fullPath.includes('checkout')"></admin-lite-navbar>

      <!-- BARRA DE NAVEGACION DE ASISTENTE -->
      <assistant-navbar v-else-if="!$route.fullPath.includes('checkout')"></assistant-navbar>

      <v-content>
        <!-- COMPONENTE PARA LAS TRANSICIONES ENTRE VISTAS -->
        <vue-page-transition name="fade">
          <router-view />
        </vue-page-transition>
        <!-- NAVEGACIÓN INFERIOR EN PREVISUALIZACIÓN Y DETALLE DE EVENTO DE UN ADMIN-->
        <admin-bottom-navbar v-if="inEventPreview"></admin-bottom-navbar>
        <event-bottom-navbar v-if="inEventDetail && user.role!='ORGANIZER'&&!ticketsOutOfStock"></event-bottom-navbar>
      </v-content>
    </v-sheet>

    <!-- NOTIFICACIONES DEL SITIO -->
    <v-snackbar
      :multi-line="true"
      :top="true"
      :right="true"
      :timeout="time"
      v-model="isVisible"
      :color="color"
    >{{ text }}</v-snackbar>
    <!-- NOTIFICACIONES DEL SITIO -->

    <!-- LOADER DEL SITIO -->
    <v-overlay
      opacity="1"
      color="white"
      v-model="loaderVisible"
      :style="( user.role == 'ATTENDEE')?'margin-top:75':(user.role == 'ORGANIZER')?'':'margin-top:64px'"
    >
      <v-dialog hide-overlay persistent width="unset" v-model="loaderVisible">
        <v-card color="primary" class="px-5 pt-5 pb-0">
          <v-card-text class="white--text px-5 text-center">
            <v-img
              src="@/assets/logo-WC.png"
              :contain="true"
              width="380"
              class="mx-3 mt-0 mb-5"
            ></v-img>
            <v-progress-linear indeterminate color="secondary" class="mb-1"></v-progress-linear>
            <p>{{ loaderMessage }}</p>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>
    <!-- LOADER DEL SITIO -->
  </v-app>
</template>

<script>
import navbar from "./components/landing/navbar";
import adminNavbar from "./components/admin/admin-navbar";
import adminBottomNavbar from "./components/admin/admin-bottom-navbar";
import adminLiteNavbar from "./components/admin/admin-lite-navbar";
import assistantNavbar from "./components/assistant/assistant-navbar";
import eventBottomNavbar from "./components/shared/products/event-bottom-navbar";
import { mapState, mapMutations } from "vuex";
export default {
  name: "App",
  components: {
    navbar,
    adminNavbar,
    adminLiteNavbar,
    assistantNavbar,
    eventBottomNavbar,
    adminBottomNavbar
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("user", [
      "loggedIn",
      "inEventPreview",
      "inEventDetail",
      "user"
    ]),
    ...mapState("notifications", ["text", "color", "time", "visible"]),
    ...mapState("loader", ["loaderMessage", "loaderVisible"]),
    ...mapState("event", ["currentEvent", "ticketsOutOfStock"]),
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.hide();
      }
    }
  },
  methods: {
    ...mapMutations("notifications", ["hide"]),
    ...mapMutations("loader", ["loading", "loaded"])
  },
  created() {
    if (this.loggedIn && this.user.role == "ORGANIZER") {
      this.$router.push("/dashboard/inicio");
    } else if (this.loggedIn && this.user.role == "LITE_ORGANIZER") {
      this.$router.push("/dashboard/lite");
    }
  }
};
</script>